
//Device token key in local storage
var localStorageDeviceToken = 'token';

/**
 * @description checks for device_token and adds appropriate headers
 * @param config : request interceptor configuration object
 */
const authorizeRequest = config => {
  const deviceToken = localStorage?.getItem(localStorageDeviceToken);
  if (deviceToken) {
    config.headers['device-token'] = deviceToken;
  }
};

/**
 * @description processes unauthorized
 * @param error : error object returned from failed response
 * @returns original error object
 */
const processUnauthorized = error => {
  if (error.response.status === 401) {
    localStorage.removeItem(localStorageDeviceToken);
    console.log(error);
  }
  return error;
};

// adds interceptors to middleware chain
export default api => {
  api.interceptors.request.use(config => {
    authorizeRequest(config);
    return config;
  });

  // always return Promise.reject on error, or it will not be caught by try/catch block
  api.interceptors.response.use(
    response => response,
    error => {
      processUnauthorized(error);
      return Promise.reject(error);
    }
  );

  return api;
};
